// Маппер ячеек — raw snake_case → camelCase DTO

import type { LocationDto, LocationRaw } from '../types/location.types';

export function mapLocation(raw: LocationRaw): LocationDto {
  return {
    id: raw.id,
    warehouseId: raw.warehouse_id,
    code: raw.code,
    zone: raw.zone,
    rack: raw.rack,
    shelf: raw.shelf,
    position: raw.position,
    barcode: raw.barcode,
    type: raw.type,
    isActive: !!raw.is_active,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  };
}
